import { NgModule } from '@angular/core';
import { NgxLogglyModule } from 'ngx-loggly-logger';
import { EwMainLoaderComponent } from './components/ew-main-loader/ew-main-loader.component';
import { EwListLoaderComponent } from './components/ew-list-loader/ew-list-loader.component';
import { EwSectionLoaderComponent } from './components/ew-section-loader/ew-section-loader.component';
import { EwDialogBoxComponent } from './components/ew-dialog-box/ew-dialog-box.component';
import { EwMaterialComponentsModule } from './ew-material-components.module';
import { CapitalizePipe } from './pipes/Capitalize.pipe';
import { CommonModule } from '@angular/common';
import { CustomAutofocusDirective } from './directivies/custom-autofocus.directive';
import { EwDeleteDialogboxComponent } from './components/ew-delete-dialogbox/ew-delete-dialogbox.component';

@NgModule({
  declarations: [
    CapitalizePipe,
    EwMainLoaderComponent,
    EwListLoaderComponent,
    EwSectionLoaderComponent,
    EwDialogBoxComponent,
    CustomAutofocusDirective,
    EwDeleteDialogboxComponent
  ],
  imports: [NgxLogglyModule.forRoot(), EwMaterialComponentsModule, CommonModule],
  exports: [
    CapitalizePipe,
    EwMainLoaderComponent,
    EwListLoaderComponent,
    EwSectionLoaderComponent,
    EwDialogBoxComponent,
    CustomAutofocusDirective,
    EwDeleteDialogboxComponent
  ]
})
export class EwCommonModule {}
